import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ItemList from 'flarum/common/utils/ItemList';
import PollGroupList from './PollGroup/PollGroupList';
import PollGroupListState from '../states/PollGroupListState';
import PollPageHero from './PollPageHero';
export default class PollGroupListPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('canViewPollGroups')) {
      m.route.set('/');
      return;
    }
    this.state = new PollGroupListState({
      sort: m.route.param('sort'),
      filter: m.route.param('filter')
    });
    this.state.refresh();
  }
  view() {
    return m(PageStructure, {
      className: "PollGroupListPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: !this.state
    }, this.contentItems().toArray());
  }
  hero() {
    return m(PollPageHero, {
      title: app.translator.trans('fof-polls.forum.poll_groups.list_page.title'),
      icon: "fas fa-layer-group"
    });
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    items.add('pollGroupList', m(PollGroupList, {
      state: this.state
    }), 10);
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollGroupListPage', PollGroupListPage);